/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AllocationName } from '../models/AllocationName';
import type { CapTableName } from '../models/CapTableName';
import type { CommonCompanyProfile } from '../models/CommonCompanyProfile';
import type { CommonCompanyProfileNews } from '../models/CommonCompanyProfileNews';
import type { CommonCompanyProfileSuggest } from '../models/CommonCompanyProfileSuggest';
import type { CommonCompanyProfileSuggestResponse } from '../models/CommonCompanyProfileSuggestResponse';
import type { CommonCompanyProfileWrite } from '../models/CommonCompanyProfileWrite';
import type { CommonProfileCompany } from '../models/CommonProfileCompany';
import type { Company } from '../models/Company';
import type { CompanyCapIQFundingRounds } from '../models/CompanyCapIQFundingRounds';
import type { CompanyCapIQOverview } from '../models/CompanyCapIQOverview';
import type { CompanyFinancialHistory } from '../models/CompanyFinancialHistory';
import type { CompanyFundingRounds } from '../models/CompanyFundingRounds';
import type { CompanyLinkProfile } from '../models/CompanyLinkProfile';
import type { CompanyQuestionSync } from '../models/CompanyQuestionSync';
import type { ConfirmProfileBody } from '../models/ConfirmProfileBody';
import type { EdgarIssuerName } from '../models/EdgarIssuerName';
import type { EdgarIssuerNameUpdate } from '../models/EdgarIssuerNameUpdate';
import type { Investment } from '../models/Investment';
import type { KeyDevelopmentList } from '../models/KeyDevelopmentList';
import type { MergeProfileSave } from '../models/MergeProfileSave';
import type { MutualFundMarksResponse } from '../models/MutualFundMarksResponse';
import type { RetrieveDocumentGenerationJob } from '../models/RetrieveDocumentGenerationJob';
import type { TimeSeriesResponse } from '../models/TimeSeriesResponse';
import type { ZanbatoAskPricingResponse } from '../models/ZanbatoAskPricingResponse';
import type { ZanbatoBidPricingResponse } from '../models/ZanbatoBidPricingResponse';
import type { ZanbatoClosedTransactionsResponse } from '../models/ZanbatoClosedTransactionsResponse';
import type { ZanbatoPricingResponse } from '../models/ZanbatoPricingResponse';
import type { ZanbatoReportedMarksResponse } from '../models/ZanbatoReportedMarksResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompaniesService {
  /**
   * @param search A search term.
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesList(
    search?: string,
    page?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/companies/common-profiles/',
      query: {
        'search': search,
        'page': page,
      },
    });
  }
  /**
   * @param data
   * @returns CommonCompanyProfile
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesCreate(
    data: CommonCompanyProfileWrite,
  ): CancelablePromise<CommonCompanyProfile> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/companies/common-profiles/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns CommonCompanyProfileSuggestResponse
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesSuggestCreate(
    data: CommonCompanyProfileSuggest,
  ): CancelablePromise<CommonCompanyProfileSuggestResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/companies/common-profiles/suggest/',
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this common company profile.
   * @returns any
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesRead(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/companies/common-profiles/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this common company profile.
   * @param data
   * @returns CommonCompanyProfile
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesUpdate(
    id: number,
    data: CommonCompanyProfileWrite,
  ): CancelablePromise<CommonCompanyProfile> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/companies/common-profiles/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this common company profile.
   * @param data
   * @returns CommonCompanyProfile
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesPartialUpdate(
    id: number,
    data: CommonCompanyProfileWrite,
  ): CancelablePromise<CommonCompanyProfile> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/companies/common-profiles/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this common company profile.
   * @returns void
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesDelete(
    id: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/companies/common-profiles/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * List companies linked to a specific CommonCompanyProfile, with firm name.
   * @param id
   * @returns CommonProfileCompany
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesCompaniesList(
    id: string,
  ): CancelablePromise<Array<CommonProfileCompany>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/companies/common-profiles/{id}/companies/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * List all EdgarIssuerName records linked to a specific CommonCompanyProfile.
   * @param id
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesEdgarIssuerNamesList(
    id: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<EdgarIssuerName>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/companies/common-profiles/{id}/edgar-issuer-names/',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this common company profile.
   * @param data
   * @returns CommonCompanyProfile
   * @throws ApiError
   */
  public static apiCompaniesCommonProfilesMergeCreate(
    id: number,
    data: MergeProfileSave,
  ): CancelablePromise<CommonCompanyProfile> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/companies/common-profiles/{id}/merge/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * Search all EdgarIssuerName records. Pass ?unlinked=true to filter to unmatched only.
   * @param search A search term.
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiCompaniesEdgarIssuerNamesList(
    search?: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<EdgarIssuerName>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/companies/edgar-issuer-names/',
      query: {
        'search': search,
        'page': page,
      },
    });
  }
  /**
   * Update (link or unlink) a single EdgarIssuerName record.
   * @param id A unique integer value identifying this edgar issuer name.
   * @param data
   * @returns EdgarIssuerNameUpdate
   * @throws ApiError
   */
  public static apiCompaniesEdgarIssuerNamesPartialUpdate(
    id: number,
    data: EdgarIssuerNameUpdate,
  ): CancelablePromise<EdgarIssuerNameUpdate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/companies/edgar-issuer-names/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param cmdId
   * @returns any
   * @throws ApiError
   */
  public static apiCompaniesFiscalEndDatesRead(
    cmdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/companies/fiscal-end-dates/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
    });
  }
  /**
   * Extract tables from specified PDF pages and return as Excel data.
   * Expected request data:
   * {
     * "page_numbers": [1, 2, 3]  # List of page numbers to process
     * }
     * @param companyId
     * @param fileId
     * @param data
     * @returns RetrieveDocumentGenerationJob
     * @throws ApiError
     */
    public static apiCompaniesDocumentsConversionCreate(
      companyId: string,
      fileId: string,
      data: RetrieveDocumentGenerationJob,
    ): CancelablePromise<RetrieveDocumentGenerationJob> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/{company_id}/documents/{file_id}/conversion',
        path: {
          'company_id': companyId,
          'file_id': fileId,
        },
        body: data,
      });
    }
    /**
     * @param companyPk
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAllocationValuesRead(
      companyPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{company_pk}/allocation-values',
        path: {
          'company_pk': companyPk,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesRead(
      id: number,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesUpdate(
      id: number,
      data: Company,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesPartialUpdate(
      id: number,
      data: Company,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns void
     * @throws ApiError
     */
    public static apiCompaniesDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAllocationsList(
      id: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<AllocationName>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/allocations',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @param fileType
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAssetSignedUrlRead(
      id: string,
      fileType: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/asset-signed-url/{file_type}',
        path: {
          'id': id,
          'file_type': fileType,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns void
     * @throws ApiError
     */
    public static apiCompaniesCapIqCacheRefreshCreate(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/{id}/cap-iq-cache/refresh',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns CompanyCapIQFundingRounds
     * @throws ApiError
     */
    public static apiCompaniesCapIqFundingRoundsRead(
      id: number,
    ): CancelablePromise<CompanyCapIQFundingRounds> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/cap-iq-funding-rounds',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns CompanyCapIQOverview
     * @throws ApiError
     */
    public static apiCompaniesCapIqOverviewRead(
      id: number,
    ): CancelablePromise<CompanyCapIQOverview> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/cap-iq-overview/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @param mp Measurement date ID
     * @param cmd Command ID for measurement date
     * @param includeConvertibleNotes Include convertible notes in the response
     * @returns CapTableName
     * @throws ApiError
     */
    public static apiCompaniesCapTablesList(
      id: string,
      page?: number,
      mp?: number,
      cmd?: number,
      includeConvertibleNotes: boolean = false,
    ): CancelablePromise<Array<CapTableName>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/cap-tables',
        path: {
          'id': id,
        },
        query: {
          'page': page,
          'mp': mp,
          'cmd': cmd,
          'include_convertible_notes': includeConvertibleNotes,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyLinkProfile
     * @throws ApiError
     */
    public static apiCompaniesCommonProfileUpdate(
      id: number,
      data: CompanyLinkProfile,
    ): CancelablePromise<CompanyLinkProfile> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/{id}/common-profile',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyLinkProfile
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilePartialUpdate(
      id: number,
      data: CompanyLinkProfile,
    ): CancelablePromise<CompanyLinkProfile> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}/common-profile',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns ConfirmProfileBody
     * @throws ApiError
     */
    public static apiCompaniesConfirmProfilePartialUpdate(
      id: number,
      data: ConfirmProfileBody,
    ): CancelablePromise<ConfirmProfileBody> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}/confirm-profile',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param basePeriod Aggregation period: 'quarter' or 'year'
     * @returns CompanyFinancialHistory
     * @throws ApiError
     */
    public static apiCompaniesFinancialHistoryRead(
      id: number,
      basePeriod: 'quarter' | 'year' = 'quarter',
    ): CancelablePromise<CompanyFinancialHistory> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/financial-history',
        path: {
          'id': id,
        },
        query: {
          'base_period': basePeriod,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns CompanyFundingRounds
     * @throws ApiError
     */
    public static apiCompaniesFundingRoundsRead(
      id: number,
    ): CancelablePromise<CompanyFundingRounds> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/funding-rounds',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param mdId
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesHasSummaryRead(
      id: string,
      mdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/has-summary/{md_id}',
        path: {
          'id': id,
          'md_id': mdId,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param categories Cap IQ key dev category codes, e.g. C2,C3. Defaults to C2 with fallback.
     * @param startRank
     * @param endRank
     * @returns KeyDevelopmentList
     * @throws ApiError
     */
    public static apiCompaniesKeyDevelopmentsRead(
      id: number,
      categories?: Array<string>,
      startRank: number = 1,
      endRank: number = 100,
    ): CancelablePromise<KeyDevelopmentList> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/key-developments',
        path: {
          'id': id,
        },
        query: {
          'categories': categories,
          'start_rank': startRank,
          'end_rank': endRank,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsInvestedCapitalRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/invested-capital',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsMoicRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/moic',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsUnrealizedValueRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/unrealized-value',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns MutualFundMarksResponse
     * @throws ApiError
     */
    public static apiCompaniesMutualFundMarksRead(
      id: number,
    ): CancelablePromise<MutualFundMarksResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/mutual-fund-marks/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param pageAfter Cursor for the next page of results
     * @param pageBefore Cursor for the previous page of results
     * @param releaseDateStart Filter news on or after this date (YYYY-MM-DD)
     * @param releaseDateEnd Filter news on or before this date (YYYY-MM-DD)
     * @param pageSize Number of results per page
     * @returns CommonCompanyProfileNews
     * @throws ApiError
     */
    public static apiCompaniesNewsRead(
      id: number,
      pageAfter?: string,
      pageBefore?: string,
      releaseDateStart?: string,
      releaseDateEnd?: string,
      pageSize: number = 20,
    ): CancelablePromise<CommonCompanyProfileNews> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/news',
        path: {
          'id': id,
        },
        query: {
          'page_after': pageAfter,
          'page_before': pageBefore,
          'release_date_start': releaseDateStart,
          'release_date_end': releaseDateEnd,
          'page_size': pageSize,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns void
     * @throws ApiError
     */
    public static apiCompaniesSacraCacheRefreshCreate(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/{id}/sacra-cache/refresh',
        path: {
          'id': id,
        },
      });
    }
    /**
     * Returns a list of investments for a company at a specific measurement date
     * @param id
     * @param mdId
     * @returns Investment A list of Investments
     * @throws ApiError
     */
    public static apiCompaniesSummaryRead(
      id: string,
      mdId: string,
    ): CancelablePromise<Array<Investment>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/summary/{md_id}',
        path: {
          'id': id,
          'md_id': mdId,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyQuestionSync
     * @throws ApiError
     */
    public static apiCompaniesSyncCompanyQuestionsUpdate(
      id: number,
      data: CompanyQuestionSync,
    ): CancelablePromise<CompanyQuestionSync> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/{id}/sync-company-questions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyQuestionSync
     * @throws ApiError
     */
    public static apiCompaniesSyncCompanyQuestionsPartialUpdate(
      id: number,
      data: CompanyQuestionSync,
    ): CancelablePromise<CompanyQuestionSync> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}/sync-company-questions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoAskPricingResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoAskPricingRead(
      id: number,
    ): CancelablePromise<ZanbatoAskPricingResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-ask-pricing',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoBidPricingResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoBidPricingRead(
      id: number,
    ): CancelablePromise<ZanbatoBidPricingResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-bid-pricing',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoClosedTransactionsResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoClosedTransactionsRead(
      id: number,
    ): CancelablePromise<ZanbatoClosedTransactionsResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-closed-transactions',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoPricingResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoPricingRead(
      id: number,
    ): CancelablePromise<ZanbatoPricingResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-pricing',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoReportedMarksResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoReportedMarksRead(
      id: number,
    ): CancelablePromise<ZanbatoReportedMarksResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-reported-marks',
        path: {
          'id': id,
        },
      });
    }
  }
